//  picks which of the four viewers to load based on the file's 
// type, and only loads that one — the other three viewers' code 
// isn't 
// even downloaded to the browser until you actually need them.

import { lazy, ComponentType } from 'react';
import { PreviewDocType } from '../types';
import { RendererProps } from './types';

// Each renderer is lazy-loaded so its parser stays out of the main bundle —
// pdfjs (~380KB), xlsx (~150KB), and docx-preview+jszip (~140KB gzipped)
// only load when a document of that type is actually opened.
export const RENDERERS: Record<PreviewDocType, ComponentType<RendererProps>> = {
  pdf: lazy(() => import('./PdfRenderer')),
  docx: lazy(() => import('./DocxRenderer')),
  xlsx: lazy(() => import('./XlsxRenderer')),
  csv: lazy(() => import('./CsvRenderer')),
};
